import splitBreakpoints from '../split-breakpoints'

function parseFontSize ({ size, unit }) {
  return { fontSize: `${size}${unit}` }
}

export default splitBreakpoints(parseFontSize)
